import styled from '@emotion/styled'

export const CardOnFileContainer = styled.div`
  border: 1px solid #dee2e6;
  border-radius: 10px;
  font-family: 'Open Sans';
  display: flex;
  flex-direction: column;
  background: white;
  padding: 16px;
  width: 100%;
`
export const CardOnFileTitle = styled.h3`
  font-size: 16px;
  font-weight: 700;
  font-family: 'Open Sans';
  margin: 0;
`
export const CardOnFileDescription = styled.p`
  font-family: Open Sans;
  font-weight: 400;
  font-style: Regular;
  font-size: 10px;
  leading-trim: NONE;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  margin: 0;
`
export const CardOnFileBox = styled.div`
  border: 1px solid #dee2e6;
  border-radius: 0px 10px 10px 0px;
  padding: 12px;
  border: 1px solid #dde1ea;
  background-color: #f1f5ff;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  gap: 10px;
  max-width: ${({isMobile}) => (isMobile ? 'none' : '202px')};
  width: ${({isMobile}) => (isMobile ? '100%' : 'auto')};
  transform: ${({isMobile}) => (isMobile ? 'none' : 'translateX(-50px)')};
  padding: 12px;
  padding-left: ${({isMobile}) => (isMobile ? '12px' : 'calc(16px + 50px)')};
  border-radius: ${({isMobile}) => (isMobile ? '10px' : '0px 10px 10px 0px')};
  z-index: 0;
`

export const CardOnFileCardBox = styled(CardOnFileBox)`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const CardOnFileNumber = styled.h4`
  font-size: 16px;
  font-weight: 700;
  font-family: 'Open Sans';
  margin: 0;
`
export const CardOnFileIcon = styled.img`
  height: 64px;
  width: auto;
`
export const CardOnFileCVCInput = styled.input`
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 8px;

  &:placeholder {
    color: rgb(89, 96, 102);
  }

  height: 24;
  border-radius: 5px;
  padding: 5px;
  gap: 19px;
  angle: 0 deg;
  opacity: 1;
  border-width: 1px;

  border: 1px solid #bfbfbf;

  font-family: Inter;
  font-weight: 400;
  font-style: Regular;
  font-size: 10px;
  leading-trim: NONE;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
`
export const CardOnFileLabel = styled.label`
  font-family: Open Sans;
  font-weight: 700;
  font-style: Bold;
  font-size: 10px;
  leading-trim: NONE;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  margin: 0;
`
export const CardOnFileActions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
`

export const CardOnFilePrimaryButton = styled.button`
  height: 35px;
  border-radius: 5px;
  gap: 10px;
  angle: 0 deg;
  opacity: 1;
  border-width: 1px;
  padding-right: 20px;
  padding-left: 20px;

  border: 1px solid #ff5000;

  font-family: Open Sans;
  font-weight: 700;
  font-style: Bold;
  font-size: 12px;
  leading-trim: NONE;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  color: #ff5000;
  background: #ffffff;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:hover {
    background: #ff5000;
    color: #ffffff;
  }
`
export const CardOnFileSecondaryButton = styled.button`
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding-block: 12px;
  padding-inline: 16px;
  font-size: 14px;
  font-weight: 600;
`
